import * as React from 'react';
const Svg3D = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.533 7.312a.238.238 0 00-.119-.206L12.12 2.894a.239.239 0 00-.238 0L4.585 7.106a.239.239 0 00-.119.206v9.377c0 .084.046.163.12.206l7.295 4.212a.238.238 0 00.238 0l7.295-4.212a.238.238 0 00.12-.206V7.312zm1.43 9.377c-.001.595-.318 1.145-.834 1.443l-7.296 4.212a1.668 1.668 0 01-1.667 0l-7.295-4.212a1.667 1.667 0 01-.833-1.443V7.312c0-.596.318-1.146.833-1.444l7.295-4.212a1.668 1.668 0 011.667 0l7.296 4.212c.516.298.833.848.833 1.444v9.377z"
        fill="currentColor"
      />
      <path
        d="M19.857 7.238l.362.615-7.597 4.47a1.668 1.668 0 01-1.728-.023l-7.13-4.456.758-1.211 7.129 4.455c.075.047.17.049.247.004l7.597-4.469.362.615z"
        fill="currentColor"
      />
      <path d="M12.549 12.074v9.877h-1.428v-9.877h1.428z" fill="currentColor" />
      <path
        d="M11.158 11.626v-.233a.75.75 0 011.496-.077l.004.077v.233a.75.75 0 01-1.5 0zm0-2.08v-.46a.75.75 0 011.5 0v.46a.75.75 0 01-1.5 0zm0-2.307v-.462a.75.75 0 011.5 0v.462a.75.75 0 01-1.5 0zm0-2.308V4.47a.75.75 0 011.5 0v.46a.75.75 0 01-1.5 0zm0-2.308V2.39a.75.75 0 011.5 0v.233a.75.75 0 01-1.496.077l-.004-.077z"
        fill="currentColor"
      />
      <path
        d="M19.252 16.402a.75.75 0 011.034-.237l.192.121a.75.75 0 01-.729 1.309l-.067-.038-.193-.121a.75.75 0 01-.237-1.034zm-1.926-1.209a.75.75 0 01.967-.274l.067.038.385.241a.75.75 0 01-.73 1.308l-.067-.037-.386-.241-.062-.045a.75.75 0 01-.174-.99zM15.4 13.986a.75.75 0 01.967-.275l.068.038.385.241a.75.75 0 01-.797 1.27l-.385-.24-.064-.045a.75.75 0 01-.174-.99zm-1.925-1.21a.75.75 0 01.966-.274l.068.038.385.241a.75.75 0 01-.73 1.309l-.067-.038-.386-.241-.063-.044a.75.75 0 01-.173-.99zm-1.735-1.087a.75.75 0 01.968-.275l.066.037.194.121a.75.75 0 01-.798 1.27l-.192-.12-.064-.044a.75.75 0 01-.174-.99z"
        fill="currentColor"
      />
      <path
        d="M4.748 16.402a.75.75 0 00-1.034-.237l-.192.121a.75.75 0 00.729 1.309l.067-.038.193-.121a.75.75 0 00.237-1.034zm1.926-1.209a.75.75 0 00-.967-.274l-.067.038-.385.241a.75.75 0 00.73 1.308l.067-.037.386-.241.062-.045a.75.75 0 00.174-.99zM8.6 13.986a.75.75 0 00-.967-.275l-.068.038-.385.241a.75.75 0 00.798 1.27l.384-.24.064-.045a.75.75 0 00.174-.99zm1.925-1.21a.75.75 0 00-.966-.274l-.068.038-.385.241a.75.75 0 00.73 1.309l.067-.038.386-.241.063-.044a.75.75 0 00.173-.99zm1.735-1.087a.751.751 0 00-.968-.275l-.066.037-.194.121a.75.75 0 00.798 1.27l.193-.12.063-.044a.75.75 0 00.174-.99z"
        fill="currentColor"
      />
    </svg>
  );
};
const MemoSvg3D = React.memo(Svg3D);
export default MemoSvg3D;
